module.exports = __webpack_public_path__ + "img/ex-mini.0a3f2631.png";